export default async function getAffiche({ context, nextMiddleware }){
    try {
        context.store.dispatch('menuUI/selectTab', 'affiche');
    }
    catch(e){
        console.error(e);
        return context.next(false);
    }
    return nextMiddleware()
}
